<template lang="pug">
.fileupload
  template(v-if="uploadErrors && uploadErrors.length > 0")
    div.fu-error.p-a-0
      small {{ $t('fileupload.upload_failed') }}
      ul(v-if="uploadErrors && uploadErrors.length > 0").p-a-0.p-l-4.m-a-0.m-b-2
        li(v-for="(error, index) in uploadErrors", :key="index") {{ error }}
  template(v-if="fileErrors && fileErrors.length > 0")
    div.fu-error.p-a-0
      small {{ $t('fileupload.upload_file_error') }}
      ul(v-if="fileErrors && fileErrors.length > 0").p-a-0.p-l-4.m-a-0.m-b-2
        li(v-for="(error, index) in fileErrors", :key="index") {{ error }}
  .uploadarea(:class="{'highlighted': uploadareaHighlighted}", :style="areaSizeStyle")
    template(v-if="largeFile")
      span.filename {{ fileName }}
    template(v-else)
      template(v-if="fileupload !== ''")
        img(:src="fileupload")
      template(v-else-if="existingFile")
        img(:src="existingFile")
    small(:class="{'hover': fileupload !== '' || existingFile}")
      template(v-if="existingFile") {{ uploadTextExisting }}
      template(v-else) {{ uploadText }}
        template(v-if="largeFile && fileUploaded"): h2.m-t-2 File successfully uploaded!
    input(type="file", @change="fileEvent($event.target.files)", @dragenter="highlight(true)", @dragleave="highlight(false)")
    .done(:class="{'show': state === 'success'}")
      i.mdi.mdi-cloud-check.fileupload-mdi
    .uploading(:class="{'show': state === 'uploading'}")
      i.mdi.mdi-spin.mdi-loading.fileupload-mdi
      template(v-if="largeFile"): span {{ progress }}%
  div(v-if="useUnsplash").t-c.p-a-1.unsplashlink
    small {{ $t('fileupload.or_click') }}&nbsp;
      a(href="", @click.prevent="toggleModal(true)") {{ $t('fileupload.here') }}
      | &nbsp;{{ $t('fileupload.to_choose_an_image_from') }}&nbsp;
      a(href="https://unsplash.com?utm_source=streamify&utm_medium=referral", target="_blank").lowkeyLink Unsplash.
  ul(v-if="uploadCriteria && uploadCriteria.length > 0").p-a-0.p-l-4.m-a-0.m-t-2
    li(v-for="(criteria, index) in uploadCriteria", :key="index") {{ criteria }}
  template(v-if="useUnsplash")
    portal(to="modals")
      Modal(:show="unsplashModal", @close="toggleModal(false)").unsplashModal.state
        header
          h2 {{ $t('fileupload.find_and_choose_unsplash') }}
          FormInput(type="text" :outline="true" :placeholder="$t('fileupload.search_placeholder')", v-model="unsplash.search", :value="unsplash.search")
        .modal-content(:class="{'center': unsplash.loading}")
          template(v-if="unsplash.loading")
            i.mdi.mdi-magnify
            p.state-text {{ $t('upload.searching_unsplash')}}..
          .result(v-else)
            .image(v-for="image in unsplash.searchResult.results", @click="selectUnsplashImage($event, image)")
              img(:src="image.urls.thumb")
              small {{ $t('fileupload.photo_by') }}&nbsp;
                a(:href="`https://unsplash.com/@${image.user.username}?utm_source=streamify&utm_medium=referral`", target="_blank") {{ image.user.name }}&nbsp;
                | {{ $t('fileupload.on') }}&nbsp;
                a(href="https://unsplash.com?utm_source=streamify&utm_medium=referral", target="_blank") Unsplash
          .unsplash-pagination(v-if="unsplash.searchResult.results.length > 0 && !unsplash.loading")
            small(v-if="unsplash.currentPage > 1 && unsplash.searchResult.results.length > 0", @click="prevPage").mr-a {{ $t('fileupload.prev_page') }}
            small(v-if="unsplash.currentPage < unsplash.searchResult.total_pages", @click="nextPage").ml-a {{ $t('fileupload.next_page') }}
</template>

<script>

export default {
  props: {
    state: {
      type: String,
      validator: (value) => {
        const validStates = ['', 'error', 'success', 'uploading', 'unload'];
        return validStates.indexOf(value) !== -1;
      },
    },
    existingFile: String,
    maxSize: Number,
    uploadCriteria: Array,
    uploadText: String,
    uploadTextExisting: String,
    validFormats: Array,
    useUnsplash: Boolean,
    largeFile: Boolean,
    progress: Number,
    // areaSize: Array,
    areaSize: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    areaSizeStyle() {
      const [width = '', height = ''] = this.areaSize;
      if (width && height) {
        return {
          width,
          height,
        };
      }
      return null;
    },
  },
  watch: {
    state(val) {
      if (val === 'uploading' && this.largeFile) {
        this.fileUploaded = false;
      }

      if (val === 'unload' && this.largeFile) {
        this.$el.querySelector('input[type="file"]').value = '';
        this.fileName = '';
      }

      if (val === 'error') {
        this.uploadErrors.push(this.$t('fileupload.upload_failed_try_again'));
        return;
      }

      if (val === 'success') { // && this.largeFile) {
        this.fileUploaded = true;
        this.fileName = '';
        this.$el.querySelector('input').value = '';
      }
      this.uploadErrors = [];
    },
    // eslint-disable-next-line
    'unsplash.search'(val) {
      if (val === '') {
        this.unsplash.searchResult.results = [];
        this.unsplash.currentPage = 1;
        this.unsplash.searchResult.total = 0;
        this.unsplash.searchResult.total_pages = 0;
        return;
      }
      clearTimeout(this.unsplash.searchTimer);
      this.unsplash.searchTimer = setTimeout(() => {
        this.searchUnsplash(val);
      }, 600);
    },
  },
  data() {
    return {
      uploadareaHighlighted: false,
      unsplashModal: false,
      fileupload: '',
      fileUploaded: false,
      uploadErrors: [],
      fileErrors: [],
      showDone: false,
      showUploading: false,
      selectingUnsplashImage: false,
      fileName: '',
      unsplash: {
        key: process.env.VUE_APP_UNSPLASHKEY,
        search: '',
        currentPage: 1,
        searchTimer: null,
        loading: false,
        searchResult: {
          total: 0,
          total_pages: 0,
          results: [],
        },
      },
    };
  },
  methods: {
    toggleModal(bool) {
      if (bool) {
        this.unsplashModal = true;
      } else {
        this.unsplashModal = false;
      }
    },
    highlight(bool) {
      this.uploadareaHighlighted = bool;
    },
    fileEvent(files) {
      if (files.length === 0) {
        return;
      }
      this.uploadErrors = [];
      this.fileErrors = [];

      if (files.length > 1) {
        this.fileErrors.push(this.$t('fileupload.onefile_error'));
      }

      if (!this.largeFile) {
        if ((files[0].size / 1024 / 1024) > this.maxSize) {
          this.fileErrors.push(this.$t('fileupload.maxsize_error'));
        }
      }

      let foundValidType = false;
      for (let i = 0; i < this.validFormats.length; i += 1) {
        if (files[0].type.indexOf(this.validFormats[i]) >= 0) {
          foundValidType = true;
        }
      }

      if (!foundValidType) {
        this.fileErrors.push(this.$t('fileupload.format_error'));
      }

      if (this.fileErrors.length > 0) {
        this.fileupload = '';
        this.highlight(false);
        return;
      }

      if (this.largeFile) {
        this.fileName = files[0].name;
        const formData = new FormData();
        formData.append('file', files[0]);
        const title = files[0].name;
        this.$emit('filedata', formData, title);
      } else {
        const formData = new FormData();
        const reader = new FileReader();

        reader.onload = (e) => {
          this.fileupload = e.target.result;
          formData.append('file', files[0]);
          this.$emit('filedata', formData);
        };

        reader.readAsDataURL(files[0]);
      }
    },
    nextPage() {
      // eslint-disable-next-line
      this.unsplash.currentPage = this.unsplash.currentPage + 1;
      this.searchUnsplash(this.unsplash.search);
    },
    prevPage() {
      // eslint-disable-next-line
      this.unsplash.currentPage = this.unsplash.currentPage - 1;
      this.searchUnsplash(this.unsplash.search);
    },
    async selectUnsplashImage(e, image) {
      if (this.selectingUnsplashImage) return;
      if (e.target.tagName.toLowerCase() === 'a') return;

      this.selectingUnsplashImage = true;

      const response = await ovpFetch(`${image.links.download_location}&client_id=${this.unsplash.key}`, {
        noAuth: true,
        noExtraHeaders: true,
        // headers: {
        //  Authorization: `Client-ID ${this.unsplash.key}`,
        //},
      }).catch(() => false);
      if (!response) return;

      const imageResponse = await ovpFetch(`${response.data.url}&client_id=${this.unsplash.key}`, {
        responseType: 'blob',
        noAuth: true,
        noExtraHeaders: true,
        // headers: {
        //  Authorization: `Client-ID ${this.unsplash.key}`,
        // },
      }).catch(() => false);

      this.selectingUnsplashImage = false;

      if (!imageResponse) {
        return;
      }

      this.fileEvent([imageResponse.data]);
      this.unsplashModal = false;
    },
    async searchUnsplash(searchString) {
      this.unsplash.loading = true;

      const result = await ovpFetch(`https://api.unsplash.com/search/photos?client_id=${this.unsplash.key}&page=${this.unsplash.currentPage}&per_page=12&query=${searchString}&orientation=landscape`, {
        noAuth: true,
        noExtraHeaders: true,
        // headers: {
        //  Authorization: `Client-ID ${this.unsplash.key}`,
        // },
      }).catch(() => false);

      this.unsplash.loading = false;
      this.unsplash.searchResult.total = result.data.total;
      this.unsplash.searchResult.total_pages = result.data.total_pages;
      this.unsplash.searchResult.results = result.data.results;
    },
  },
};
</script>

<style lang="sass" scoped>

@import '../variables.sass'

.filename
  word-break: break-all

.fu-error
  small, li
    color: $alertColor

.poster-size
  .uploadarea
    &::after
      content: ""
      width: 1px
      padding-top: 56%

.uploadarea
  align-items: center
  justify-content: center
  flex-direction: column
  display: flex
  background-color: #f7f7f7
  border: 2px dashed #ebeef0
  line-height: 1
  padding: .5rem
  position: relative
  text-align: center
  transition: border-color .4s
  &:hover
    small.hover
      opacity: 1
  small
    color: lighten(black, 20%)
    display: block
    padding: 1rem
    &.hover
      background: rgba(255, 255, 255, .7)
      height: 100%
      position: absolute
      left: 0
      top: 0
      opacity: 0
      width: 100%
      transition: opacity .4s
      display: flex
      align-items: center
      justify-content: center
  & > *
    pointer-events: none
  img
    height: auto
    max-width: 100%
    max-height: 100%
  input
    cursor: pointer
    height: 100%
    left: 0
    opacity: 0
    position: absolute
    pointer-events: all
    top: 0
    width: 100%
  &.highlighted
    border-color: #4fcf4f
  .done, .uploading
    align-items: center
    display: flex
    height: 100%
    justify-content: center
    left: 0
    position: absolute
    top: 0
    width: 100%
    opacity: 0
    transition: opacity .2s
    &.show
      background: rgba(255, 255, 255, .7)
      opacity: 1
    i
      color: #4fcf4f
      font-size: 3rem
  .uploading
    i
      color: black

ul
  li
    color: #848484
    font-size: 12px
.unsplashlink
  a
    font-weight: 700
  .lowkeyLink
    font-weight: normal
</style>

<style lang="sass">
.unsplashModal
  .result
    display: flex
    flex-wrap: wrap
    & > *
      margin: 5px
      position: relative
      width: 100%
      @media (min-width: 600px)
        max-width: calc(50% - 10px)
      @media (min-width: 800px)
        max-width: calc(33.3333% - 10px)
      &:hover
        cursor: pointer
        small
          opacity: 1
      small
        background-color: rgba(0, 0, 0, .5)
        bottom: 0
        color: white
        display: block
        left: 0
        opacity: 0
        padding: 5px
        position: absolute
        right: 0
        transition: opacity .4s
      img
        display: block
        height: 100%
        max-width: 100%
        width: 100%
  .unsplash-pagination
    display: flex
    small:hover
      cursor: pointer
  .unsplash-meta
    margin-top: 2rem
    i
      font-size: 2rem
.unsplashModalInner
  flex: 1
  padding: 2rem
  position: relative
  text-align: center
  .closeModal
    position: absolute
    right: 10px
    top: 10px
    &:hover
      cursor: pointer
    i
      font-size: 30px
</style>
